// frontend/src/pages/booking/components/ProgressIndicator.js
import React from 'react';

const ProgressIndicator = ({ steps, currentStep, onStepClick }) => {
  const currentIndex = steps.findIndex(s => s.id === currentStep);

  return (
    <div className="bg-gray-800 rounded-2xl p-6 mb-8">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const isCompleted = index < currentIndex;
          const isCurrent = step.id === currentStep;
          // FIXED: Allow clicking on completed steps and current step, but not future steps
          const isClickable = isCompleted || isCurrent;

          return (
            <React.Fragment key={step.id}>
              <div
                onClick={() => isClickable && onStepClick(step.id)}
                className={`flex flex-col items-center flex-1 transition-all ${
                  isClickable ? 'cursor-pointer hover:scale-105' : 'cursor-not-allowed'
                } ${
                  isCompleted ? 'opacity-100' : isCurrent ? 'opacity-100' : 'opacity-50'
                }`}
              >
                <div
                  className={`w-16 h-16 rounded-full flex items-center justify-center text-2xl mb-2 transition-all duration-300 ${
                    isCompleted
                      ? 'bg-emerald-600 text-white hover:bg-emerald-700'
                      : isCurrent
                        ? 'bg-emerald-600 text-white ring-4 ring-emerald-400/30 scale-110'
                        : 'bg-gray-700 text-gray-400'
                  }`}
                >
                  {isCompleted ? '✓' : step.icon}
                </div>
                <span
                  className={`text-sm font-medium text-center hidden md:block ${
                    isCurrent ? 'text-emerald-400' : isCompleted ? 'text-gray-300' : 'text-gray-400'
                  }`}
                >
                  {step.title}
                </span>
              </div>

              {index < steps.length - 1 && (
                <div className="flex-1 h-1 mx-2 bg-gray-700 rounded-full overflow-hidden">
                  <div
                    className={`h-full transition-all duration-500 ${
                      isCompleted ? 'bg-emerald-600 w-full' : 'bg-gray-700 w-0'
                    }`}
                  ></div>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
      
      {/* ADDED: Help text for users */}
      <div className="mt-4 text-center">
        <p className="text-sm text-gray-400">
          💡 Click on completed steps to go back and edit your information
        </p>
      </div>
    </div>
  );
};

export default ProgressIndicator;